const useSkeleton = (root) => {
  const skeleton = {
    layout: {
      values: "",
      content: {
        values: "app-main",
        header: {
          values: "page-header",
          icon: {
            values: "page-header-icon",
          },
          info: {
            values: "flex flex-column",
            route: { values: "page-header-route" },
            title: { values: "page-header-title" },
          },
          actions: {
            values: "page-header-actions",
          },
        },
      },
    },
    commons: {
      dataTableContainer: { values: "table-container w-full" },
    },
    abm: {
      values: "flex justify-content-center w-full",
      form: {
        values: "abm-form-layout flex flex-column w-10",
        field: {
          values: "abm-form-field flex align-items-center w-full",
          label: { values: "abm-form-label flex pt-3 pr-4 w-4 h-2 justify-content-end" },
          value: {
            values: "abm-form-value flex flex-column w-7 justify-content-start",
            error: { values: "abm-form-error flex h-1rem justify-content-start" },
            control: {
              values: "abm-form-control flex flex-column justify-content-start",
            },
          },
        },
      },
    },
    withholdings: {
      values: "wh-form",
      header: {
        values: "wh-header",
        field: {
          values: "wh-field",
          label: { values: "wh-field-label" },
          control: {
            values: "wh-field-control",
          },
        },
        summary: {
          values: "wh-summary",
          title: {
            values: "wh-section-title",
          },
          rows: {
            values: "wh-summary-rows",
            row: { values: "wh-summary-row" },
          },
        },
        actions: {
          values: "wh-actions",
          action: {
            values: "wh-action-card",
            title: {
              values: "wh-section-title",
            },
            rows: {
              values: "wh-action-body",
              row: {
                values: "wh-action-row",
                column: {
                  values: "wh-action-col",
                },
              },
            },
          },
        },
        button: {
          values: "p-button-secondary wh-action-btn",
        },
      },
    },
  };

  const getObject = (jsonItem, baseSkeleton) => {
    let result = baseSkeleton;

    const fields = jsonItem.toString().split(".");

    for (let i = 0; i < fields.length; i++) {
      result = result[fields[i]];
    }

    return result;
  };

  // Usar getObject para inicializar currentSkeleton
  let currentSkeleton = root ? getObject(root, skeleton) : skeleton;

  const get = (jsonItem) => {
    let result = currentSkeleton;

    if (jsonItem) {
      result = getObject(jsonItem, currentSkeleton);
    }
    result = result?.values ? result.values.replaceAll(",", " ") : "";

    return result;
  };

  return {
    get,
  };
};

export default useSkeleton;
